import { WorkingtimeArray } from '../../../types/workingtime/WorkingtimeGetResponse';
import { formatYmDisplay } from '../../../utils/formatYmDisplay';

interface RenderWorkingtimeRowProps {
  item: WorkingtimeArray;
}

const RenderWorkingtimeRow = ({ item }: RenderWorkingtimeRowProps) => {
  return (
    <>
      <td>{item.employeeCode}</td>
      <td>{item.employeeName}</td>
      <td>{formatYmDisplay(item.date)}</td>
      <td>{item.workingTime}</td>
      <td>{item.productiveHours}</td>
      <td>{item.unproductiveHours}</td>
      <td>{item.productiveRatio}%</td>
      <td>{item.weekdayWorkingTime}</td>
      <td>{item.weekdayOvertime}</td>
      <td>{item.weekendWorkingTime}</td>
    </>
  );
};

export default RenderWorkingtimeRow;
